import { Selectable } from "./abstractions/Selectable";

export class Year extends Selectable {
    code: string;
    value: string;

    constructor(code: string, value: string, selected: boolean) {
        super(value, code);
        this.code = code;
        this.value = value;
        this.selected = selected;
    }
}
